import { excludeProps } from '@lokalise/styled';

import styled from '@app/styled';
import { withInputContainerStyle } from '@app/styles';
import { color, spacing, typography } from '@app/theme';

export const Placeholder = styled.div`
    ${typography('custom.description')};
    color: ${color('custom.content.secondary')};
    display: inline-flex;
    position: absolute;
`;

export const InputContainer = styled.div.withConfig({ shouldForwardProp: excludeProps(['error']) })<{ error: boolean }>`
    ${withInputContainerStyle};

    align-items: center;
    padding: ${spacing(1, 8, 1, 2)};
    color: ${color('custom.content.secondary')};
    position: relative;

    display: flex;
    gap: ${spacing(1)};
    flex-wrap: wrap;
`;

export const Input = styled.input`
    flex: 1;
    width: 0;
    min-width: 150px;
    outline: none;
    border: 0 none;
    padding: 0;
    display: inline-flex;
    height: 25px;
    min-height: 25px;
    line-height: 25px;
    color: ${color('custom.content.primary')};
    background-color: transparent;

    &&:focus-visible {
        outline: none !important;
    }
`;

export const Container = styled.div`
    width: 100%;
    display: grid;
    gap: ${spacing(1)};
    position: relative;
`;

export const ClearWrapper = styled.div`
    position: absolute;
    right: 9px;
    top: 6px;
`;
